import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

export interface WorkloadMetric {
  value: number;
  label: string;
  colorClass: string;
}

@Component({
  selector: 'app-circular-metric',
  templateUrl: './circular-metric.component.html',
  styleUrls: ['./circular-metric.component.scss'],
  imports: [NgClass],
})
export class CircularMetricComponent {
  public value = input.required<number>();
  public label = input.required<string>();
  public colorClass = input.required<string>();
  public loading = input<boolean>(false);
}
